import type { JSX } from 'react'

import { BANNER_ASPECT_RATIO } from 'vars/banner-aspect-ratio'
import { BANNER_WIDTH } from 'vars/banner-width'
import { BannerSkeletonSC } from './BannerSkeleton.styled'

export interface IBannerSkeletonComponentProps {
  ref?: React.Ref<HTMLDivElement>
  aspectRatio?: BANNER_ASPECT_RATIO
  bannerWidth?: BANNER_WIDTH
}

export const BannerSkeleton = ({
  ref,
  aspectRatio = BANNER_ASPECT_RATIO.SKELETON_DEFAULT,
  bannerWidth = BANNER_WIDTH.SIZE_100,
}: IBannerSkeletonComponentProps): JSX.Element => {
  return (
    <BannerSkeletonSC
      ref={ref}
      aspectRatio={aspectRatio}
      bannerWidth={bannerWidth}
    />
  )
}
